import React from 'react'
import { Iframe } from 'component-library/content/Iframe/Iframe'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'
import { ConsentLevel } from 'common/data/consent/consent.redux'

export interface IframeRouteProps {
    link: string
    height: number
    marginBottom?: keyof ThemeMargins
    sandbox?: string
    consentRequiredLevel?: ConsentLevel
}

export const IframeRegistration = createRegisterableComponent(
    'iframe',
    (props: IframeRouteProps, services) => (
        <Iframe key={`iframe${services.location.pathname}`} {...props} /> // key required to use location to force remount
    )
)
